import MBoxPanel from './MBoxPanel';

export default MBoxPanel;
